"use client";
import { Container, Paper } from "@mantine/core";
import classes from "./legal-layout.module.css";

export default function LegalLayout({
  children,
}: {
  children: React.ReactElement;
}) {
  return (
    <Container size="xl" className={classes.container}>
    <Paper withBorder className={classes.paper}>
      {children}
    </Paper>
    </Container>
  );
}
